<template>
  <div class="wrapper">
    <div class="t bgw">
      <div class="shop-container">
        <router-link to="/">
          <div class="logo-icon">
            <img :src="this.$store.state.config.shop_logo" alt>
          </div>
          <div class="logo-text">{{this.$store.state.config.shop_name}}</div>
        </router-link>
      </div>
    </div>
    <div class="main shop-container">
      <div class="timetip bgw">
        <i class="icon iconfont iconerror"></i>请在
        <template>
          <span>{{hour? hourString+':'+minuteString+':'+secondString : minuteString+':'+secondString}}</span>
        </template>
        时间内完成支付，超时订单将会自动取消
      </div>
      <div class="count-title bgw">
        <div class="l">
          <div class="head">项目：</div>
          <div class="item-list" v-if="orderInfo.order_type!=9">
            <div v-for="(item,index) in orderInfo.items" :key="index" class="item-li">{{item.name}}</div>
          </div>
          <div v-else>
              <div class="item-list">
            <div   class="item-li">定制项目订单</div>
            <div v-if="orderInfo.customized_status==1"   class="item-li">定制项目订单保证金</div>
                <div v-if="orderInfo.customized_status==4"   class="item-li">定制项目订单首付款</div>
                <div v-if="orderInfo.customized_status==4||orderInfo.customized_status==7"   class="item-li">
                  <DesTable v-if="orderInfo.mark&&orderInfo.customized_status>=4" :price="orderInfo.order_amount" :configstr="orderInfo.mark" :file_path="orderInfo.file_path"></DesTable>
                </div>
          </div>
          </div>
        </div>


      </div>

        <div v-if="orderInfo.order_type==9 && (orderInfo.customized_status==1 || orderInfo.customized_status==4 ||orderInfo.customized_status==7)" class="order-box bgw " style="padding: 14px">
            <div class="box-title">

                <h3 class="addressh3">收货地址</h3>
            </div>
            <div>
                <div class="box-info adress">
                    <div class="item"  v-for="(item,index) in addressList" :key="index" :class="{'active':curAddressIndex==index}"  @click="selectCurAddress(item,index)">
                        <div class="name">{{item.name}}</div>
                        <div class="tel">{{item.mobile}}</div>
                        <div class="tel">{{item.idcard_no}}</div>
                        <div class="address">{{item.area_name}} {{item.address}}</div>
                        <div>
                            <span class="change" @click="modifyAddress(item)">修改</span>
                            <span class="default" @click="setDefault(item)" v-show="item.is_def!=1">设为默认</span>
                        </div>
                        <div class="default-icon" v-show="item.is_def==1">
                            <i class="icon iconfont icondefault"></i>
                        </div>
                    </div>
                    <div class="add-adress item" @click="addAddressFunc">
                        <i class="icon iconfont iconadd"></i>
                        添加收货地址
                    </div>
                </div>
            </div>

        </div>

      <div class="pay-box bgw">
        <div class="title">选择支付方式</div>
        <div class="box-info">
          <el-radio-group v-model="payType" @change="setpaytype">
            <el-radio :label="item.code" v-for="(item,index) in payments" :key="index" v-if="item.code!='offline'||orderInfo.order_type!=9||orderInfo.customized_status>=2">
              <span class="pay-type" :class="{'active':payType==item.code}">
                <i class="icon iconfont iconxianxiamendian" v-if="item.code=='offline'"></i>
                <i class="icon iconfont iconyuezhifu" v-else-if="item.code=='balancepay'"></i>
                <i class="icon iconfont iconzhifubao" v-else-if="item.code=='alipay'"></i>
                <i class="icon iconfont iconweixinzhifu" v-else-if="item.code=='wechatpay'"></i>
                {{item.name}}
              </span>
            </el-radio>
          </el-radio-group>
        </div>

          <el-form  class="demo-form-inline pay-box bgw" v-if="dialogFormVisible">
              <el-form-item label="对公转账凭证">
                <div class="pay_public_info">
                  <div class="pay_public_title">
                    常州灵特尔轻便展示系统有限公司
                  </div><div class="">
                    付款信息:
                </div><div class="">
                    公司名称:常州灵特尔轻便展示系统有限公司
                </div><div class="">
                    开户银行:江南农村商业银行遥观支行
                </div><div class="">
                    账号:3204214201201000012017
                </div><div class="">
                    税号:91320412K12060911W
                </div><div class="">
                    地址:江苏省常州市武进区遥观镇灵通工业园长虹东路333号
                  </div>
                </div>

                  <div slot="tip" class="el-upload__tip">请上传对公转账凭证截图</div>
                  <el-upload
                          :action="upLoadUrl"
                          :on-exceed="handleExceedVisio1"
                          list-type="picture-card"
                          :limit="1"
                          :http-request="e=>handleUpload1(e)"
                          :on-remove="handleRemove1"
                          :on-success="xxxx"
                  >
                      <i class="el-icon-plus"></i>
                  </el-upload>
                  <el-dialog :visible.sync="dialogVisible">
                      <img width="100%" :src="dialogImageUrl" alt>
                  </el-dialog>
              </el-form-item>

          </el-form>

        <div class="pay-block">
          <div class="pay-info">
            支付￥
            <span class="total-money">{{orderInfo.order_amount}}</span>
            <template v-if="get_price">
            <br>
            应付金额￥
            <span class="total-money">{{get_price}}</span>
            </template>
          </div>
        </div>
        <div class="pay-block">
          <el-button class="pay-btn" :loading="btnLoading" @click="toPay">去付款</el-button>
        </div>
      </div>
    </div>
    <template v-if="dialogPaymentShow">
      <Payment :codeImg="code_url" @clearInterPay="clearInterPay"></Payment>
    </template>
      <SelectAddress :dialogAdressVisible="dialogAddressShow" @hideDialog="hideDialog" :data="modifyData" :type="addressDialogType"></SelectAddress>




  </div>
</template>

<script>
import Payment from "@/components/payment.vue";
import { locationHost } from "@/config/env.js";
import DesTable from '@/components/zqtool/DesTable.vue';
import SelectAddress from '@/components/address/index';
import { mapActions } from 'vuex';
import {apiBaseUrl} from "@/config/env.js";
export default {
  name: "Cashier",
  components: { Payment,DesTable,SelectAddress},
  props: {},
  data() {
    return {
      payments: [],
      payType: "alipay",
      orderInfo: {},
      tabs: ['默认门店自提','快递配送'],
      tabCurrent: 1,
      code_url: "",
      modifyData: null,
      addressDialogType: 0, // 新增0 修改1
      dialogPaymentShow: false,
      intervalPayStatus: "",
      remainingTime: "",
      hour: "",
      minute: "",
      second: "",
        params:{},
        dialogFormVisible:false,
      promiseTimer: "",
      dialogAddressShow:false,
      curAddressIndex: -1,
        dialogVisible:false,
        urlimages:[],
        dialogImageUrl:false,
        upLoadUrl: apiBaseUrl + "api.html",
      btnLoading: false // 禁用btn
    };
  },
  watch: {},
  computed: {
    addressList() {
        //console.log("111",this.$store.state.addressList);
      return this.$store.state.addressList
    },
    // 判断店铺开关
    storeSwitch() {
      return this.$store.state.config.store_switch || 2;
    },
    hourString() {
      return this.formatNum(this.hour);
    },
    minuteString() {
      return this.formatNum(this.minute);
    },
    secondString() {
      return this.formatNum(this.second);
    },
    get_price(){
      if(this.orderInfo.order_type==9){
        if(this.orderInfo.customized_status==4){
          return 0.6*Number(this.orderInfo.order_amount)-Number(this.orderInfo.payed);
        }else{
          return Number(this.orderInfo.order_amount)-Number(this.orderInfo.payed);
        }
      }else{
        return this.orderInfo.order_amount;
      }
    }
  },
  methods: {
      ...mapActions(['getUserShipListAction']),
      xxxx(val){
          //console.log("val",val);
      },
      setpaytype(val){
          //console.log("setpaytype",val);
          if("offline"==val){
              this.dialogFormVisible=true;
          }else{
              this.dialogFormVisible=false;
          }
      },
      selectCurAddress(item, index) {
          this.curAddressIndex = index
          this.params.area_id = item.area_id
          this.userShip = item
      },
      handlePictureCardPreview(file) {
          this.dialogImageUrl = file.url;
          this.dialogVisible = true;
      },
      handleUpload1(e) {
          var formdata = new FormData();
          formdata.append("upfile", e.file, e.file.name);
          this.$api.uploadImage(this.upLoadUrl, formdata).then(res => {
              if (res.status) {
                  this.urlimages = this.urlimages.concat(res.data.image_id);
              } else {
                  this.$msg(res.msg, "error");
              }
          });
      },
      //上传图片
      handleExceedVisio1() {
          this.$message.warning(`当前限制选择 1 个图片，请删除后继续上传！`)
      },
      handleRemove1(file, fileList) {
          console.log(file, fileList);
          this.urlimages = [];
      },
      hideDialog() {
          this.dialogAddressShow = false
      },
    addAddressFunc() {
      this.dialogAddressShow = true
      this.modifyData = {}
    },
    modifyAddress(item) {
      this.modifyData = item
      this.dialogAddressShow = true
    },
    setDefault(item) {
      this.$api.setDefShip({ id: item.id }).then(res => {
        if (res.status) {
          this.$msg('设置默认地址成功')
          this.getUserShipListAction() //添加成功获取最新列表
        }
      })
    },

    toPay() {
        if (!this.userShip.id || !this.params.area_id) {
            this.$msg('请选择收货地址', 'warning')
            this.btnLoading = false
            return false
        }
        // 快递配送
        let delivery = {
            uship_id: this.userShip.id,
            area_id: this.params.area_id,
        }
      this.btnLoading = true;
      let code = this.payType;
      if (code == "wechatpay") {
        let data = {
          ids: this.order_id,
          payment_code: code,
          payment_type: 1,
          params: {
            trade_type: "NATIVE"
          }
        };
        data = Object.assign(data, delivery);
        // 微信h5支付
        this.$api.pay(data).then(res => {
          this.btnLoading = false;
          if (res.status) {
            this.dialogPaymentShow = true;
            this.code_url = res.data.code_url;
            this.getPaymentStatus(res.data.payment_id);
          } else {
            this.$msg(res.msg, "error");
          }
        }).catch(() => {
            this.btnLoading = false;
        });
      } else if (code == "alipay") {
        let data = {
          ids: this.order_id,
          payment_code: code,
          payment_type: 1,
          params: {
            trade_type: "PC",
            return_url:
              locationHost+ "/#/cashier/" + this.order_id
          }
        };
        data = Object.assign(data, delivery);
        this.$api.pay(data).then(res => {
          this.btnLoading = false;
          if (res.status) {
            this.standarPost(res.data.url, res.data.data);
          }
        }).catch(() => {
            this.btnLoading = false;
        });
      } else if (code == "balancepay") {
        let data = {
          ids: this.order_id,
          payment_code: code,
          payment_type: 1
        };
        data = Object.assign(data, delivery);
        this.$api.pay(data).then(res => {
            this.btnLoading = false;
          if (res.status && res.msg == "支付成功") {
            this.$msg("支付成功");
            this.toPaySuccess();
          } else {
            this.$msg(res.msg, "warning");
          }
        }).catch(() => {
            this.btnLoading = false;
        });
      } else if (code == "offline") {
            if(this.urlimages.length==0){
                this.$msg("请上传对公付款凭证", "error");
                this.btnLoading = false;
                return false;
            }
          let data={order_id:this.order_id,urlimages:this.urlimages}
          this.$api.payToCompany(data).then(res => {
              this.btnLoading = false;
              if (res.status) {
                  this.$msg("支付成功");
                  this.toPaySuccess();
              }else {
                  this.$msg(res.msg, "warning");
              }
          }).catch(() => {
              this.btnLoading = false;
          });
      }
    },
    standarPost(url, data) {
      let tempForm = document.createElement("form");
      tempForm.id = "aliPay";
      tempForm.methods = "post";
      tempForm.action = url;
      tempForm.target = "_self";
      let input = [];
      for (let k in data) {
        input[k] = document.createElement("input");
        input[k].type = "hidden";
        input[k].name = k;
        input[k].value = data[k];
        tempForm.appendChild(input[k]);
      }
      tempForm.addEventListener("submit", function() {}, false);
      document.body.appendChild(tempForm);
      tempForm.dispatchEvent(new Event("submit"));
      tempForm.submit();
      document.body.removeChild(tempForm);
    },
    clearInterPay() {
      clearInterval(this.intervalPayStatus);
      this.dialogPaymentShow = false;
    },
    toPaySuccess() {
      this.$router.replace({
        name: "paySuccess",
        query: { order_id: this.order_id }
      });
    },
    getPaymentStatus(id) {
      let data = {
        payment_id: id
      };
      let that = this;
      this.intervalPayStatus = setInterval(function() {
        that.$api.paymentInfo(data).then(res => {
          if (res.status) {
            if (res.data.status == 2) {
              that.$msg("支付成功");
              that.toPaySuccess();
            }
          }
        });
      }, 1000);
    },
    getPaymentType() {
      this.$api.paymentList().then(res => {
        let data = res.data;
        this.payments = data;
      });
    },
    getOrderDetail() {
      let data = {
        order_id: this.order_id
      };
      this.$api.orderDetail(data).then(res => {
        if (res.status) {
          this.orderInfo = res.data;
          console.dir(res.data)
          let remainingTime = res.data.remaining_time;
          this.remainingTime = remainingTime;
          console.log(this.remainingTime);
          this.getCountDownTime(remainingTime);
          if (res.data.pay_status == 2) {
            this.toPaySuccess();
          }
        }
      });
    },
    getCountDownTime(time) {
      if (Number(time) > 0) {
        this.hour = Math.floor(time / 3600);
        this.minute = Math.floor((time / 60) % 60);
        this.second = Math.floor(time % 60);
        this.countDown();
      }
    },
      // 获取用户的默认收货地址
      userDefaultShip() {
          this.$api.userDefaultShip({}).then(res => {
              if (res.status && Object.keys(res.data).length) {
                  this.userShip = res.data
                  console.log("res.data",res.data);
                  this.params.area_id = res.data.area_id
              }
          })
      },

      // 获取收货地址列表
      userShipList() {
          this.getUserShipListAction()
      },
    countDown() {
      let that = this;
      clearInterval(this.promiseTimer);
      this.promiseTimer = setInterval(function() {
        if (that.hour === 0) {
          if (that.minute !== 0 && that.second === 0) {
            that.second = 59;
            that.minute -= 1;
          } else if (that.minute === 0 && that.second === 0) {
            that.second = 0;
            clearInterval(that.promiseTimer);
          } else {
            that.second -= 1;
          }
        } else {
          if (that.minute !== 0 && that.second === 0) {
            that.second = 59;
            that.minute -= 1;
          } else if (that.minute === 0 && that.second === 0) {
            that.hour -= 1;
            that.minute = 59;
            that.second = 59;
          } else {
            that.second -= 1;
          }
        }
      }, 1000);
    },
    formatNum(num) {
      return num < 10 ? "0" + num : " " + num;
    }
  },
  created() {
  },
  mounted() {
    let orderId = this.$route.params.order_id;
    this.order_id = orderId;
    this.getPaymentType();
    this.getOrderDetail();
      this.userDefaultShip()
      this.userShipList()
  },
  destroyed() {
    clearInterval(this.promiseTimer);
    clearInterval(this.intervalPayStatus);
  }
};
</script>
<style lang="scss" scoped>
@import "@/assets/css/variable.scss";
@import "@/assets/css/mixin.scss";
.wrapper {
  .main {
    .timetip {
      height: 40px;
      line-height: 40px;
      text-align: center;
      margin: 16px auto;
      color: #757575;
      .icon {
        color: #757575;
        margin-right: 5px;
      }
    }
    .count-title {
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
      padding: 14px;
      margin-bottom: 10px;
      .l {
        display: inline-flex;
        .head {
          width: 60px;
          height: auto;
          line-height: 30px;
        }
        .item-list {
          .item-li {
            height: auto;
            line-height: 30px;
          }
        }
      }
      .total {
        color: $theme-color;
        font-size: 12px;
        height: 30px;
        line-height: 30px;
        &-money {
          font-size: 24px;
        }
      }
    }
    .pay-box {
      padding: 14px;
      margin-bottom: 20px;
      .title {
        margin-bottom: 20px;
      }
      .box-info {
        display: flex;
        margin-bottom: 40px;
        .pay-type {
          display: inline-block;
          width: 130px;
          height: 36px;
          line-height: 32px;
          text-align: center;
          border: 1px solid $border;
          transition: all 0.2s;
          cursor: pointer;
          padding: 1px;
          box-sizing: border-box;
          &.active,
          &:hover {
            border-color: $theme-color;
          }
        }
      }
      .pay-block {
        height: 50px;
        .pay-info {
          float: right;
          color: $theme-color;
          .total-money {
            font-size: 24px;
          }
        }
        .pay-btn {
          float: right;
          // width: 90px;
          // height: 32px;
          line-height: 6px;
          border-radius: 16px;
          text-align: center;
          background: $theme-color;
          color: #fff;
          cursor: pointer;
        }
      }
    }
  }

  .t {
    border-bottom: 2px solid $theme-color;
    height: 100px;
    .shop-container {
      padding-top: 30px;
      .logo-icon {
        float: left;
        width: 48px;
        height: 48px;
        margin-right: 10px;
        img {
          width: 100%;
          height: auto;
        }
      }
      .logo-text {
        float: left;
        margin-top: 0px;
        font-size: 20px;
        color: #424242;
        line-height: 48px;
        margin-right: 20px;
      }
      .tip {
        float: left;
        line-height: 20px;
        margin-top: 20px;
        font-size: 12px;
        color: #757575;
      }
      .group {
        float: right;
        margin-top: 20px;
        display: flex;
        color: #757575;
        font-size: 12px;
        .item {
          height: 40px;
          line-height: 40px;
          cursor: pointer;
        }
        .line {
          height: 20px;
          line-height: 20px;
          color: #757575;
          margin-top: 10px;
          margin: 10px 10px 0;
        }
      }
    }
  }
}
.box-info {
    padding: 20px 0px;
    display: flex;
    align-items: center;
    font-size: 14px;
    flex-flow: row wrap;
    &.invoice {
        span {
            padding: 0 8px;
            color: $theme-color;
            &.modify {
                cursor: pointer;
                &:hover {
                    color: $theme-color;
                }
            }
        }
    }
    &.adress {
        display: flex;
        box-sizing:border-box;
        flex-wrap: wrap;
        justify-content: space-between;
        .item {
            width: 24%;
            box-sizing:border-box;
            height: 180px;
            border: 1px solid $border;
            text-align: left;
            cursor: pointer;
            padding: 20px;
            box-sizing: border-box;
            position: relative;
            margin-left: 0px;
            margin-bottom: 20px;
            .default-icon {
                position: absolute;
                top: 0;
                right: 0;
                .icon {
                    font-size: 48px;
                    color: $theme-color;
                }
            }
            &.active {
                border-color: $theme-color;
                .change,
                .default {
                    visibility: visible;
                }
            }
            .name {
                line-height: 30px;
                font-size: 24px;
                margin-bottom: 10px;
            }
            .tel,
            .address {
                line-height: 22px;
                color: #757575;
                margin-bottom: 5px;
            }
            .change {
                position: absolute;
                right: 14px;
                bottom: 20px;
                cursor: pointer;
                color: $theme-color;
                visibility: hidden;
            }
            .default {
                position: absolute;
                right: 70px;
                bottom: 20px;
                cursor: pointer;
                color: $theme-color;
                visibility: hidden;
            }
            &.add-adress {
                text-align: center;
                color: #999;
                transition: all 0.4s ease;
                &:hover {
                    border-color: #333;
                    color: #333;
                    .icon {
                        color: #333;
                    }
                }
                .icon {
                    display: block;
                    width: 30px;
                    height: 30px;
                    margin: 43px auto 8px;
                    font-size: 30px;
                    line-height: 30px;
                    border-radius: 17px;
                    transition: all 0.4s ease;
                    color: #e0e0e0;
                }
            }
        }
    }
    .pay-type {
        width: 130px;
        @include line-height(36px);
        text-align: center;
        border: 1px solid $border;
        margin-right: 30px;
        transition: all 0.2s;
        cursor: pointer;
        padding: 1px;
        box-sizing: border-box;
        &.active,
        &:hover {
            background: $theme-color;
            color: #fff;
            border: none;
        }
    }
}
.addressh3 {
    height: 40px;
    line-height: 40px;
    font-weight: 550;
    margin-right: 60px;
}
::v-deep .el-form demo-form-inline{
        padding: 20px;
    }
</style>